import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import { ApiPath } from '../../models/api-path';
import { VerifyUserDataApiModel } from '../../models/auth/token.model';
import { checkPasswordApiModel, checkUserLoginApiModel, checkUserMobileApiModel, saveUserInfoApiModel, snedMobileOtpApiModel, UserAddressApiModel, UserEmailApiModel, userInfoApiModel, userLoginApiModel, userMobileApiModel, UserProFileApiModel } from '../../models/profile/profile';
import { VerifyUserDataModel } from '../../view-models/login';
import { checkPasswordModel, getInfoThaid, saveEmailModel, savePasswordModel, snedMobileOtpModel, UserAddressModel, UserEmailModel, userInfoModel, userLoginModel, userMobileModel, UserProFileDetailSaveModel, UserProFileModel } from '../../view-models/profile';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private apiService: ApiService,
  ) { }

  async getUserEmail(): Promise<UserEmailModel> {
    const result = await this.apiService.get<UserEmailApiModel>(`/profile/email-get`)
    return result!
  }

  async getUserDetail(): Promise<UserProFileModel> {
    const result = await this.apiService.get<UserProFileApiModel>(`/profile/detail-get`)
    return result!
  }
  async saveDetail(item: UserProFileDetailSaveModel): Promise<boolean> {
    const result = await this.apiService.patch<boolean>(`/profile/detail-save`, item)
    return result!
  }


  async getUserAddress(): Promise<UserAddressModel> {
    const result = await this.apiService.get<UserAddressApiModel>(`/profile/address-get`)
    return result!
  }

  async saveUserAddressH(item: UserAddressModel): Promise<boolean> {
    const request = {
      acC_NO_H: item.acC_NO_H,
      acC_MOO_H: item.acC_MOO_H,
      acC_SOI_H: item.acC_SOI_H,
      acC_ROAD_H: item.acC_ROAD_H,
      taM_ID_H: item.taM_ID_H,
      amP_ID_H: item.amP_ID_H,
      proV_ID_H: item.proV_ID_H,
      acC_POSTCODE_H: item.acC_POSTCODE_H,
      acC_TEL_H: item.acC_TEL_H,
      acC_FAX_H: item.acC_FAX_H,
      countrY_ID_H: item.countrY_ID_H,
      adD_FOREIGN_H: item.adD_FOREIGN_H,
    }
    const result = await this.apiService.patch<boolean>(`/profile/addressH-save`, request)
    return result!
  }

  async saveUserAddressC(item: UserAddressModel): Promise<boolean> {
    const request = {
      acC_NO_C: item.acC_NO_C,
      acC_MOO_C: item.acC_MOO_C,
      acC_SOI_C: item.acC_SOI_C,
      acC_ROAD_C: item.acC_ROAD_C,
      taM_ID_C: item.taM_ID_C,
      amP_ID_C: item.amP_ID_C,
      proV_ID_C: item.proV_ID_C,
      acC_POSTCODE_C: item.acC_POSTCODE_C,
      acC_TEL_C: item.acC_TEL_C,
      acC_FAX_C: item.acC_FAX_C,
      countrY_ID_C: item.countrY_ID_C,
      adD_FOREIGN_C: item.adD_FOREIGN_C,
    }
    const result = await this.apiService.patch<boolean>(`/profile/addressC-save`, request)
    return result!
  }



  async getUserMobile(): Promise<userMobileModel> {
    const result = await this.apiService.get<userMobileApiModel>(`/profile/mobile-get`)
    return result!
  }

  async checkUserMobile(mobile: string): Promise<checkUserMobileApiModel> {
    const request = {
      mobile: mobile
    }
    const result = await this.apiService.post<checkUserMobileApiModel>(`/profile/mobile-check`, request)
    return result!
  }

  async mobileSendOtp(mobile: string): Promise<snedMobileOtpModel> {
    const request = {
      mobile: mobile
    }
    const result = await this.apiService.post<snedMobileOtpApiModel>(`/profile/mobile-send-otp`, request)
    return result!
  }

  async saveMobile(item: snedMobileOtpModel, password: string): Promise<boolean> {
    const request = {
      mobile: item.mobile,
      otp: item.otp,
      refOTP: item.refOTP,
      password: password
    }
    const result = await this.apiService.patch<boolean>(`/profile/mobile-confirm`, request)
    return result!
  }

  async getUserInfo(): Promise<userInfoModel> {
    const result = await this.apiService.get<userInfoApiModel>(`/profile/info-get`)
    return result!
  }

  async saveUserInfo(item: userInfoModel, password: string): Promise<boolean> {
    const request = {
      userName: item.userName,
      userSurname: item.userSurname,
      laserCode: item.laserCode,
      birthDate: item.birthDate,
      password: password
    }
    const result = await this.apiService.patch<boolean>(`/profile/info-save`, request)
    return result!
  }

  async getUserLogin(): Promise<userLoginModel> {
    const result = await this.apiService.get<userLoginApiModel>(`/profile/userlogin-get`)
    return result!
  }

  async checkUserLogin(userLogin: string): Promise<checkUserLoginApiModel> {
    const request = {
      userLogin: userLogin
    }
    const result = await this.apiService.post<checkUserLoginApiModel>(`/profile/check-userlogin`, request)
    return result!
  }

  async saveUserLogin(userName: string, password: string): Promise<boolean> {
    const request = {
      userLogin: userName,
      password: password,
    }

    const result = await this.apiService.patch<boolean>(`/profile/userlogin-save`, request)
    return result!
  }



  async checkPassword(password: string): Promise<checkPasswordApiModel> {
    const request = {
      password: password
    }
    const result = await this.apiService.post<checkPasswordApiModel>(`/profile/check-password`, request)
    return result!
  }

  async savePassword(item: savePasswordModel): Promise<boolean> {
    const request = {
      passwordNew: item.passwordNew,
      passwordConfirm: item.passwordConfirm,
      passwordOld: item.passwordOld
    }

    const result = await this.apiService.patch<boolean>(`/profile/password-save`, request)
    return result!
  }

  async emailSendOtp(email: string): Promise<string> {
    const request = {
      Email: email
    }
    const result = await this.apiService.post<string>(`/profile/email-send-otp`, request)
    return result!
  }

  async saveEmail(item: saveEmailModel): Promise<boolean> {
    const request = {
      email: item.email,
      password: item.password,
      otpCode: item.otpCode
    }
    const result = await this.apiService.patch<boolean>(`/profile/email-save`, request)
    return result!

  }

  async emailSendOtpSecondary(email: string): Promise<string> {
    const request = {
      Email: email
    }
    const result = await this.apiService.post<string>(`/profile/email-send-otp/secondary`, request)
    return result!
  }

  async saveEmailSecondary(item: saveEmailModel): Promise<boolean> {
    const request = {
      email: item.email,
      password: item.password,
      otpCode: item.otpCode
    }
    const result = await this.apiService.patch<boolean>(`/profile/email-save/secondary`, request)
    return result!

  }

  async getInfoThaid(code: string): Promise<getInfoThaid> {
    const infoReqForm = { code };
    const result = await this.apiService.get<getInfoThaid>(`/profile/updateinfo-thaid`, infoReqForm);

    return result!;
  }

  async updateInfoThaid(idNo: string, pid: string, given_name: string, family_name: string, birthdate: string): Promise<boolean> {
    const request = { idNo, pid, given_name, family_name, birthdate };
    const result = await this.apiService.patch<boolean>(`/profile/updateinfo-thaid-db`, request)

    return result!;
  }

}
